export enum NewsMediaEnum {
  ALL = 'All',
  ARTICLES = 'Articles',
  BLOG_ENTRY = 'Blog Entries',
}
